<!--  -->
<template>
 <div class="addNewwork">
   <div class="container">
      <div class="heart">
        <div class="tit">
          <span>提交作品</span>
        </div>

        <el-form ref="form" :model="form"  label-position="left" label-width="80px" :rules="rules">
          <el-form-item label="作者" prop="auther">
              <el-input v-model="form.auther"></el-input>
          </el-form-item>
           <el-form-item label="联系方式" prop="contact">
              <el-input v-model="form.contact "></el-input>
          </el-form-item>
           <el-form-item label="作品标题" prop="title">
              <el-input v-model="form.title"></el-input>
          </el-form-item>
           <el-form-item label="作品内容" class="tinymac" prop="cont" >
             <div class="app-container">
                <editor :curValue="content" v-model="form.cont" @input="newContent" />
              </div>
           </el-form-item>
           <el-form-item label="作品封面">
              <el-upload
                   action
                  list-type="picture-card"
                  :before-upload="beforeAvatarUpload"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-exceed = "overUpload"
                  :http-request="upLoadimg"
                  ref="uploads"
                  :limit=1
                  class="upload-demo"
                  >
                   <i slot="default" class="el-icon-plus"></i>
                    <div class="defaulttext">点击上传</div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
           </el-form-item>
        </el-form>

        <el-button class="submintBtn" :disabled="!checked" @click="submitAll">
          提交
        </el-button>

        <el-checkbox v-model="checked">
          我已阅读并悉知参赛流程。
        </el-checkbox>
      </div>
   </div>
 </div>
</template>

<script>
import {uploads, addNewwork} from '@/api/workCollect/index'
import Tinymce from '@/components/tinymce/index'
export default {
  name: 'addNew',
  components: {
    'editor': Tinymce
  },
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else {
        var phonetest = /^1(3|4|5|7|8)\d{9}$/
        if (!phonetest.test(value)) {
          callback(new Error('请输入正确格式的联系电话'))
        }
        // callback()
      }
    }
    return {
      checked: false,
      rules: {
        auther: [
          { required: true, message: '请填写作者', trigger: 'blur' }
        ],
        contact: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请填写标题', trigger: 'blur' }
        ],
        cont: [
          { required: true, message: '作品内容不能为空', trigger: 'blur' }
        ]
      },
      activityId: '',
      form: {
        auther: '',
        contact: '',
        title: '',
        cont: ''
      },
      content: '',
      dialogImageUrl: '',
      dialogVisible: false,
      params: [],
      imgarr: [],
      imgstring: '',
      columnId: ''
    }
  },
  meta: {
    showHeader: true
  },
  created () {
    this.columnId = this.$route.query.columnId
    this.activityId = this.$route.query.activityId
  },
  methods: {
    newContent (val) {
      console.log(val)
    },
    upLoadimg (param) {
      console.log(param)
      this.params.push(param)
      this.getImgs()
    },
    getImgs () {
      const paramsData = new FormData()
      this.params.forEach((it, index) => {
        paramsData.append('file', it.file)
      })
      // console.log(paramsData);
      uploads(paramsData).then(res => {
        console.log(res)
        this.imgarr = []
        res.data.data.forEach(item => {
          this.imgarr.push(item.http)
        })
        this.imgstring = this.imgarr[0]
      })
    },
    submitAll () {
      if (this.form.cont === '') {
        this.$alert('作品内容不能为空', '', {
          confirmButtonText: '确定'
        })
      } else if (this.imgstring === '') {
        this.$alert('请上传封面图片', '', {
          confirmButtonText: '确定'
        })
      } else if (/^1(3|4|5|7|8)\d{9}$/.test(this.form.contact) === false) {
        this.$alert('请输入正确格式的联系电话', '', {
          confirmButtonText: '确定'
        })
      } else if (this.form.auther === '') {
        this.$alert('请输入作者', '', {
          confirmButtonText: '确定'
        })
      } else if (this.form.title === '') {
        this.$alert('请输入作品标题', '', {
          confirmButtonText: '确定'
        })
      } else {
        const par = {
          author: this.form.auther,
          authorNo: '',
          phone: this.form.contact,
          worksTitle: this.form.title,
          content: this.form.cont,
          cover: this.imgstring,
          userId: this.$cookie.get('wlyuserid'),
          activityId: this.activityId,
          remark: ''
        }
        addNewwork(par).then(res => {
          console.log(res)
          if (res.data.status === 200) {
            this.$alert('请等待后台审核', res.data.message, {
              confirmButtonText: '确定',
              callback: () => {
                this.$router.push({
                  path: '/workCollect',
                  query: {
                    columnId: this.columnId
                  }
                })
              }
            })
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isJPG2 = file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG && !isJPG2 && !isPNG) {
        this.$message.warning('只支持jpg或png格式图片')
      }
      if (!isLt5M) {
        this.$message.warning('请上传5MB以内的图片!')
      }
      return (isJPG || isJPG2 || isPNG) && isLt5M
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove (file, fileList) {
      // console.log(file, fileList);
      this.params.forEach((item, index) => {
        if (item.file === file.raw) {
          this.params.splice(index, 1)
          this.imgarr = []
          this.imgstring = ''
        }
      })
    },
    overUpload () {
      this.$message('只能上传一张封面')
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import '../../assets/common/scss/works.scss';
.container{
  padding-bottom: 100px !important;
}

.tinymac >>> .el-form-item__content{
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/view/workCollect/addNew.vue